import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const RETAILER_TYPE = {
  OTHER: 0,
  TARFIN: 1,
  CONSUMER_GOODS: 2,
  CAR_SALES: 3,
  IYI_FINANS: 4
}

export const RETAILER_TYPE_MAP = {
  0: t('constants.retailer_type.other'),
  1: t('constants.retailer_type.tarfin'),
  2: t('constants.retailer_type.consumer_goods'),
  3: t('constants.retailer_type.car_sales'),
  4: 'Iyi Finans'
}
